import { Callout } from '../../../../../../../components';
import styles from './SetupCampaignCallout.module.scss';

export const SetupCampaignCallout = () => {
  return (
    <div className={styles.container}>
      <Callout variant="warning" size="sm">
        <Callout.Description>
          <p className={styles.description}>
            As modificações realizadas até as 22h serão aplicadas na próxima integração de dados. Após esse horário, elas refletem na integração do dia
            seguinte.
          </p>
        </Callout.Description>
      </Callout>
    </div>
  );
};
